var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZoom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.417,
    height: 21.417,
    viewBox: "0 0 21.417 21.417",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.417,
    height: 21.417,
    rx: 10,
    transform: "translate(0)",
    fill: "#4087fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.544,13.714a1.04,1.04,0,0,0-.972,1.1v5.317a2.652,2.652,0,0,0,2.479,2.8l5.758-.055a1.04,1.04,0,0,0,.972-1.1V16.4a2.72,2.72,0,0,0-2.686-2.686Z",
    transform: "translate(-4.734 -7.575)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4,15.934a1.916,1.916,0,0,0-.547,1.36v2.225a1.916,1.916,0,0,0,.547,1.36l2.161,1.9a.676.676,0,0,0,1.129-.577V14.712a.676.676,0,0,0-1.129-.577Z",
    transform: "translate(-17.044 -7.701)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.0a9d30f8f4697e68f61a96991e6886ef.svg";
export { ForwardRef as ReactComponent };